import React from 'react';
import client from '../shopify';

export default class ProductCard extends React.Component {
    render() {
        let title = this.props.product.title;
        let url = `/products/${this.props.product.handle}`;
        let imageOne = this.props.product.images[0];
        let imageTwo = this.props.product.images[1];
        let alt = `Automic Gold 14k Gold ${title}`;

        return (
            <div className='product-card-item'>
                <a href={url} title={title} className='product-card'>
                    <div className="product-card__image-holder">
                        <img
                            className='lazyload product-card__image'
                            alt={`${alt} Image One`}
                            src='//dfaankvzyirrl.cloudfront.net/website/shared/loading-image.gif'
                            data-srcset={getSrcSet(imageOne)}
                            sizes={getSizesAttribute(this.props.perRow)}
                        />
                        <picture>
                            <source
                                srcSet={getSrcSet(imageOne)}
                                sizes={getSizesAttribute(this.props.perRow)}
                                media="(hover: none)"
                            />

                            <img
                                className="lazyload product-card__image-two"
                                alt={`${alt} Image Two`}
                                data-srcset={getSrcSet(imageTwo)}
                                sizes={getSizesAttribute(this.props.perRow)}
                            />
                        </picture>
                    </div>
                    <div className='product-card__header'>
                        <div className='product-card__title'>{ title }</div>
                        <Price product={this.props.product}/>
                    </div>
                </a>
            </div>
        )
    }
}

function Price(props) {
    let lowestPrice = parseInt(props.product.variants[0].price);
    let hasRangeOfPrices = false;

    for (let i = 1; i < props.product.variants.length; i++) {
        let variantPrice = parseInt(props.product.variants[i].price);

        if (variantPrice < lowestPrice) {
            lowestPrice = variantPrice;
            hasRangeOfPrices = true;
        }
    }

    return (
        <div className='product-card__price'>
            14k solid gold / <span>$</span>{lowestPrice}{hasRangeOfPrices ? '+' : ''}
        </div>
    )
}

function getSizesAttribute(perRow = 4) {
    switch (perRow) {
        case 6:
            return `
                (max-width: 479px) calc((100vw - 30px) * 0.25),
                (min-width: 480px) and (max-width: 767.98px) calc((100vw - 60px) * 0.125),
                (min-width: 768px) calc((100vw - 120px) * 0.125)
            `;
        case 8:
            return `
                (max-width: 479px) calc((100vw - 30px) * 0.25),
                (min-width: 480px) and (max-width: 767.98px) calc((100vw - 60px) * 0.166),
                (min-width: 768px) calc((100vw - 120px) * 0.166)
            `;
        case 5:
            return `
                (max-width: 479px) calc((100vw - 30px - 15px) * 0.5),
                (min-width: 480px) and (max-width: 767.98px) calc((100vw - 60px - 15px) * 0.5),
                (min-width: 768px) and (max-width: 1199.98px) calc((100vw - 120px - 30px) * 0.2),
                (min-width: 1200px) calc((100vw - 180px - 45px) * 0.22)
            `;
        case 4:
        default:
            return `
                (max-width: 479px) calc((100vw - 30px - 15px) * 0.5),
                (min-width: 480px) and (max-width: 767.98px) calc((100vw - 60px - 15px) * 0.5),
                (min-width: 768px) and (max-width: 1199.98px) calc((100vw - 120px - 30px) * 0.333334),
                (min-width: 1200px) calc((100vw - 180px - 45px) * 0.25)
            `;
    }
}

function getSrcSet(image) {
    return `
        ${client.image.helpers.imageForSize(image, {maxWidth: 150, maxHeight: 150})} 150w,
        ${client.image.helpers.imageForSize(image, {maxWidth: 266, maxHeight: 266})} 266w,
        ${client.image.helpers.imageForSize(image, {maxWidth: 322, maxHeight: 322})} 322w,
        ${client.image.helpers.imageForSize(image, {maxWidth: 540, maxHeight: 540})} 540w,
        ${client.image.helpers.imageForSize(image, {maxWidth: 483, maxHeight: 483})} 483w,
        ${client.image.helpers.imageForSize(image, {maxWidth: 684, maxHeight: 684})} 684w,
        ${client.image.helpers.imageForSize(image, {maxWidth: 978, maxHeight: 978})} 978w,
        ${client.image.helpers.imageForSize(image, {maxWidth: 1026, maxHeight: 1026})} 1026w,
        ${client.image.helpers.imageForSize(image, {maxWidth: 574, maxHeight: 574})} 574w,
        ${client.image.helpers.imageForSize(image, {maxWidth: 861, maxHeight: 861})} 861w,
        ${client.image.helpers.imageForSize(image, {maxWidth: 1200, maxHeight: 1200})} 1200w,
        ${client.image.helpers.imageForSize(image, {maxWidth: 1500, maxHeight: 1500})} 1500w,
    `;
}
